export enum ConnectionTypeName {
  META_ADS = 'Meta Ads',
  GOOGLE_ADS = 'Google Ads',
  MICROSOFT_ADS = 'Microsoft Ads',
  REDDIT_ADS = 'Reddit',
  APPLE_ADS = 'Apple Search Ads',
  UNIVERSAL_ANALYTICS = 'Universal Analytics',
  GOOGLE_ANALYTICS_4 = 'Google Analytics 4',
  TIK_TOK = 'TikTok Ads',
  DV360 = 'Display & Video 360',
  LINKEDIN = 'LinkedIn Ads',
  PINTEREST = 'Pinterest Ads',
  SEARCH_CONSOLE = 'Search Console',
  SHOPIFY = 'Shopify',
  HUBSPOT = 'Hubspot',
  APPSFLYER = 'Appsflyer',
  OPENAI_ADS = 'OpenAi Ads',
  WOOCOMMERCE = 'WooCommerce',
}

export interface IAdverityConnection {
  id: number;
  name: ConnectionTypeName;
  type: string;
}

export type IGetAdverityConnectionTypesResponseData =
  Array<IAdverityConnection>;

export interface ICreateAdverityConnectionRequestData {
  connectionTypeId: number;
  domainName?: string;
  customerId?: string;
  appsflyerApiToken?: string;
  openAiApiKey?: string;
  woocommerceInfo?: WooCommerceSetupInfo;
}

export interface IConnectionLinkedAccount {
  linkedAccountId: string;
  adverityConnection: string;
}

export type IGetConnectionLinkedAccountResponseData = IConnectionLinkedAccount;

export interface WooCommerceSetupInfo {
  clientKey: string;
  clientSecret: string;
  domain: string;
}

export interface ICreateConnectionRequest {
  connectionTypeId: number;
  domainName?: string;
  appsflyerApiToken?: string;
  customerId?: string;
  openAiApiKey?: string;
  woocommerceInfo?: WooCommerceSetupInfo;
}

export interface IGetAuthorizedConnectionResponseData {
  is_authorized: boolean;
  is_oauth: boolean;
  status: string;
  url: string;
}

export interface IGetAdverityAvailablePlatformsResponseData {
  count: number;
  availiableConnections: Array<string>;
}

// TODO: Add new properties when more connection types exist
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ICreateFivetranConnectionRequestBody {}

export interface ICreateFivetranConnectionRequestData {
  customerId?: string;
  data?: ICreateFivetranConnectionRequestBody;
}

export interface ICreateFivetranConnectionResponseData {
  connectCardUrl: string;
}

export interface IFivetranConnection {
  id: string;
  fiveTranId: string;
  serviceName: string;
  schemaName: string;
  isAuthorized: boolean;
  isActive: boolean;
}

export interface IGetFivetranConnectionsResponseData {
  wasSuccessfull: boolean;
  errorMessage: string;
  fiveTranGroupId: string;
  connections: Array<IFivetranConnection>;
}

export interface IFivetranConnectionType {
  id: string;
  name: string;
  serviceName: string;
}

export interface IGetFivetranConnectionTypesResponseData {
  wasSuccessfull: boolean;
  errorMessage: string;
  connectionTypes: Array<IFivetranConnectionType>;
}

export interface IAuthorizeFivetranConnectionResponseData {
  wasSuccessfull: boolean;
  errorMessage: string;
  isAuthorized: boolean;
  redirectRequired: boolean;
  redirectUrl: string;
}

export interface ICancelConnectionRequestData {
  linkedAccountId: string;
  customerId?: string;
}

export interface IUnlinkConnectionRequestData {
  linkedAccountId: string;
  customerId?: string;
}
